import { HTTP } from '@util/http-p'

class CartModel extends HTTP {
    addToCart(data) {
        return this.request({
            url: 'apihome/cart/addCart',
            data: data,
            method: "POST"
        })
    }

    getCartList(data) {
        return this.request({
            url: 'apihome/cart/getCartList',
            data: data,
        })
    }

    removeOne(data) {
        return this.request({
            url: 'apihome/cart/removeOne',
            data: data,
            method: "POST"
        })
    }

    removeCart(data) {
        return this.request({
            url: 'apihome/cart/removeCart',
            data: data,
            method: "POST"
        })
    }

    updateNum(data) {
        return this.request({
            url: 'apihome/cart/updateNum',
            data: data,
            method: "POST"
        })
    }

}

export { CartModel }